import { render, staticRenderFns } from "./DefaultHeaderDropdown.vue?vue&type=template&id=2f55a9f4"
import script from "./DefaultHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports